import Mapper from './Mapper'
import { Schedule } from '@web/store/types/modules/schedule'

export interface SchedulePayload {
  time: string;
  days: number[];
  pushEnabled: boolean;
  emailEnabled: boolean;
}

export default class ScheduleMapper {
  static toClient (data: Record<string, unknown>): Schedule {
    return Mapper.converter({
      data,
      rules: {
        id: { type: 'number' },
        pushEnabled: { type: 'boolean' },
        emailEnabled: { type: 'boolean' },
        isEnabled: { type: 'boolean' },
        days: { cb: (value: unknown) => Array.isArray(value) ? value.map(Number) : [] }
      }
    }) as Schedule
  }

  static toServer (payload: SchedulePayload): SchedulePayload {
    return {
      time: payload.time.length === 5 ? `${payload.time}:00` : payload.time,
      days: payload.days,
      pushEnabled: payload.pushEnabled,
      emailEnabled: payload.emailEnabled
    }
  }
}
